import React from 'react';
import CreateKandi from '../../components/createKandi';
import UserKandis from '../../components/userKandis';
import Typography from '@mui/material/Typography';
import Fab from '@mui/material/Fab';
import AddIcon from '@mui/icons-material/Add';
import { Theme, createStyles } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';
import Grid from '@mui/material/Grid';
import Tooltip from '@mui/material/Tooltip';
import CircularProgress from '@mui/material/CircularProgress';
import SplashScreen from '../../components/splashScreen';
import { HomeProps } from './types';
import { useAuth, useAppTheme, useModal } from '../../hooks';

interface MyStyles {
    pageContainer: string;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    pageContainer: {
        paddingTop: theme.spacing(4)
    }
  })
);

const Home: React.FunctionComponent<HomeProps> = (props: HomeProps) => {
    const classes = useStyles() as MyStyles;
    
    // Use our new state management hooks
    const { isAuthenticated, isLoading, user } = useAuth();
    const createKandiModal = useModal('createKandi');
    
    // Local state for kandi refresh
    const [lastRefreshedKandi, setLastRefreshedKandi] = React.useState(Date.now());

    // Note: Drawer placeholder logic moved to App.tsx to avoid infinite loops

    // Render loading state
    if (isLoading) {
        return <CircularProgress />;
    }

    // Render signed out state
    if (!isAuthenticated) {
        return <SplashScreen />;
    }

    // Render signed in state
    return (
        <div className={classes.pageContainer}>
            <Grid container spacing={0} direction="column" alignItems="center">
                <Grid item>
                    <Typography variant="body1">
                        Welcome to KandiLove, {user?.username}!
                    </Typography>
                </Grid>
                <Grid item>
                    <UserKandis userName={user?.username || ''} lastUpdated={lastRefreshedKandi} />
                </Grid>
            </Grid>
            <CreateKandi 
                open={createKandiModal.isOpen} 
                onClose={createKandiModal.close} 
                setLastRefreshedKandi={setLastRefreshedKandi} 
            />
            <Tooltip title="Add Kandi to your collection!">
                <Fab 
                    onClick={createKandiModal.open}
                    color="primary"
                >
                    <AddIcon />
                </Fab>
            </Tooltip>
        </div>
    );
};

export default Home;
